const getJsonnetData = (baseUrl: string, brand: string, region: string, country: string, language?: string) => {
  return fetch(`${baseUrl}/${brand}-${region}-${country}-${language}.json`);
}

export default getJsonnetData